import { ChainTokenCheckResult } from '../model';
import { LiquiditySourceFactory } from './liquidity-source.factory';
import { TradeFactory } from './trade.factory';
import { TenderlySimulationFactory } from './tenderly-simulation.factory';
import { TokenFactory } from './token.factory';
import { ChainTokenCheckResultDto } from '../dto';

export class ChainTokenCheckResultFactory {
  public static createFromDto(
    dto: ChainTokenCheckResultDto,
  ): ChainTokenCheckResult {
    const result = new ChainTokenCheckResult();
    result.id = dto.id;
    result.creationDate = dto.creationDate;
    result.modificationDate = dto.modificationDate;
    result.liquiditySource = LiquiditySourceFactory.createSimpleFromDto(
      dto.liquiditySource,
    );
    result.isLiquiditySourceEnabled = dto.isLiquiditySourceEnabled;
    if (dto.trade) {
      result.trade = TradeFactory.createFromDto(
        dto.trade,
        TokenFactory.createTokenFromDto(dto.trade.from),
        TokenFactory.createTokenFromDto(dto.trade.to),
      );
    }
    if (dto.tenderlySimulation) {
      result.tenderlySimulation =
        TenderlySimulationFactory.createFromBackendDto(dto.tenderlySimulation);
    }
    return result;
  }
}
